export {Collection, type CollectionProps} from '../src/collections/CollectionBuilder';
